<template>
	<div class="login">
		<el-container>
			<el-main class="main loginMain" style="padding:0px !important;">
				<div class="disf ai-c wp100" style="justify-content: space-between;">
					<div>
						<img
							src="https://shuzhit-pos.oss-cn-shanghai.aliyuncs.com/img/pos/saas.jingzg.com/login_left.png">
					</div>

					<div class="disf bg-c-fff rad10"
						style="height:560px;width: 600px;justify-content: center;
						box-shadow: 0 12px 18px 2px rgb(34 0 51 / 4%), 0 6px 22px 4px rgb(7 48 114 / 12%), 0 6px 10px -4px rgb(14 13 26 / 12%);padding-top: 80px;">
						<div class="wp70 ta-c">
							<img src="../../assets/logo.png" style="width: 300px;">
							<p class="mt20 fs22">
								手机扫码 安全登录
							</p>
							<img v-if="qrcode != ''" class="w200 h200 title bg-c-999 m0 mt3" :src="qrcode" />
							<p>请在微信中搜索“科研论文投稿”小程序，使用小程序中最下方的“扫码登录”扫描本页面二维码，进入投稿平台。</p>
						</div>
					</div>

					<div>
						<img
							src="https://shuzhit-pos.oss-cn-shanghai.aliyuncs.com/img/pos/saas.jingzg.com/login_right.png">
					</div>
				</div>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import Cookies from "js-cookie";
	import {
		setToken
	} from '../../utils/token.js';

	export default {
		data() {
			return {
				req: {
					mobile: "",
					pwd: "",
					key: "",
					code: "",
				},
				remember: false,
				qrcode: "",
				isShowPassword: true,
				isShowScan: false,
			};
		},
		created() {
			this.refreshCode();
			let r_account = localStorage.getItem("r_account");
			if (r_account != undefined && r_account != null) {
				this.$set(this.req, "mobile", r_account);
			}
			this.code = this.identifyCode;
			let t = localStorage.getItem("r_token");
			if (t != undefined && t != null) {
				this.beginLoad({
					text: "自动登录中"
				});
				this.remember = true;
				//刷新令牌登录
				Cookies.set("refreshToken", t);
				this.$api.auth
					.refresh()
					.then((r) => {
						this.endLoad();
						if (r.Status == 1) {
							this.alert("登录成功", 1200).then(() => {
								this.$router.push("/");
							});
						} else {
							this.alertError(r.Data);
							this.loginQrcode();
						}
					})
					.catch((c) => {
						this.endLoad();
						this.alertError("授权过期，重新登录");
						this.loginQrcode();
					});
			} else {
				this.loginQrcode();
			}
		},
		methods: {
			// 扫码登陆
			scanningLogin() {
				this.isShowPassword = !this.isShowPassword;
				this.isShowScan = !this.isShowScan;
			},

			refreshCode() {
				let identifyCode = this.randomNum() + this.randomNum() + this.randomNum();
				this.$set(this.req, "key", identifyCode);
			},
			randomNum() {
				return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			},
			login() {
				if (this.req.mobile.trim() == "") {
					this.alertWarning("请输入手机号");
					return;
				}
				if (this.req.mobile.trim().length != 11) {
					this.alertWarning("手机号格式有误");
					return;
				}
				if (this.req.pwd.trim() == "") {
					this.alertWarning("请输入密码");
					return;
				}
				if (this.req.code.trim() == "") {
					this.alertWarning("请输入验证码");
					return;
				}
				this.$api.auth
					.login(this.req)
					.then((res) => {
						if (res.Status == 1) {
							localStorage.setItem("r_account", this.req.mobile);
							if (this.remember) {
								localStorage.setItem("r_token", res.Data.RefreshToken);
							} else {
								localStorage.removeItem("r_token");
							}
							this.alert("登录成功", 2000).then(() => {
								this.$router.push("/");
							});
						} else {
							localStorage.removeItem("r_token");
							this.refreshCode();
							this.alertError(res.Data);
						}
					})
					.catch((res) => {
						console.log("catch", res);
					});
			},
			forget() {
				this.$notify.closeAll();
				this.$notify.info({
					title: "提示",
					duration: 2500,
					message: "请联系管理员",
				});
			},
			loginQrcode() {
				this.signalr.start().then(async () => {
					await this.signalr.on("ConnectMessage", (msg) => {
						this.qrcode = `data:image/jpg;base64,${msg.qrcode}`;
					});

					await this.signalr.on("auth", (msg) => {
						console.log("msg", msg);
						setToken(msg);
						this.alert("登录成功", 2000).then(() => {
							this.$router.push("/");
						})
					});
				});
			},
		}
	};
</script>

<style scoped lang="scss">
	.el-container {
		height: 100vh;
		background: #f5f7ff;
	}

	.loginMain {
		background: #f5f7ff;
	}

	.leftSize {
		display: flex;
		background: url("https://shuzhit-pos.oss-cn-shanghai.aliyuncs.com/img/pos/default/login_left.png") no-repeat left center;
	}

	.rightSize {
		display: flex;
		background: url("https://shuzhit-pos.oss-cn-shanghai.aliyuncs.com/img/pos/default/login_right.png") no-repeat right center;
	}

	.el-main {
		height: 100vh;
		min-height: 470px;
		display: flex;
		align-items: center;

		.right {
			position: relative;
			top: -50px;
			width: 600px;
			margin: 0 auto;
			height: 470px;

			.rightBox {
				.logo {
					position: absolute;
					background: url("https://shuzhit-pos.oss-cn-shanghai.aliyuncs.com/img/pos/default/login_center.png") no-repeat center center;
					background-size: contain;
					width: 100px;
					height: 100px;
					left: 200px;
					top: -50px;
				}

				height: 500px;
				width: 100%;
				background: white;
				border-radius: 10px;
				box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.1);
				padding: 100px;
				padding-top: 100px;

				.title {
					letter-spacing: 3px;
					position: relative;
					top: -40px;
				}
			}
		}
	}
</style>
